import { Report19202 } from "../../../components/borrowSystem/Report/Report19202";
import { HeadTitle } from "../../../components/share/HeadTitle";
import { Footer } from "../../../components/share/Footer";
import { NavbarBorrowSystem } from "../../../components/share/NavbarBorrowSystem";

export function Report19202Container() {
  const titleName =
    "ข้อมูลทะเบียบคุมลูกหนี้เงินกู้ ตาม พระราชบัญญัติส่งเสริมการพัฒนาฝีมือแรงงาน พ.ศ. 2545";
  return (
    <div className="page-container bg-landing">
      <NavbarBorrowSystem />
      <HeadTitle title={titleName} />
      <Report19202 />
      <Footer />
    </div>
  );
}
